import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#f5f0e8]/10 last:border-0" data-id="element-11">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-12">
        <span className="text-lg md:text-xl font-serif text-[#f5f0e8] group-hover:text-[#c9a04e] transition-colors" data-id="element-13">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-[#c9a04e]" data-id="element-14" /> : <ChevronDown className="w-5 h-5 text-[#8a9bb0]" data-id="element-15" />}
      </button>
      <AnimatePresence data-id="element-16">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-17">
            <p className="pb-6 text-[#f5f0e8]/80 leading-relaxed" data-id="element-18">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Y si no me duermo igual?',
    answer: 'Entonces al menos no estás alimentando el bucle. Estás entrenando cierre. Eso se acumula.'
  }, {
    question: '¿Cuándo se nota?',
    answer: 'Algunas personas lo notan rápido. Otras hacia la noche 4–7. Tu trabajo es ejecutar, no evaluar cada minuto.'
  }, {
    question: '¿Es compatible con terapia?',
    answer: 'Sí. Es un kit de hábitos/estructura. No compite con apoyo profesional.'
  }];
  return <Section alternate data-id="element-19">
      <h2 className="text-3xl md:text-4xl text-[#f5f0e8] mb-12 text-center" data-id="element-20">
        Preguntas típicas
      </h2>
      <div className="max-w-2xl mx-auto" data-id="element-21">
        {faqs.map((faq, index) => <FAQItem key={index} {...faq} data-id="element-22" />)}
      </div>
    </Section>;
}